import { UnparsedQueryParams } from '~/providers/query-params';
import { getCookieValue } from '~/utils/for-warbler';

export function getPromoCodeFromParams(params: UnparsedQueryParams) {
  const paramKeys = Object.keys(params);
  const promoCodeKey = paramKeys.find(key => key.match(/promo/i));
  const promoCode = params[promoCodeKey as keyof UnparsedQueryParams] as string;
  return promoCode || getCookieValue('promo_code');
}
export function getProjectIdFromParams(params: UnparsedQueryParams) {
  const paramKeys = Object.keys(params);
  const projectIdKey = paramKeys.find(key => key.match(/project/i));
  const projectId = params[projectIdKey as keyof UnparsedQueryParams] as string;
  return projectId;
}
